// extracted by mini-css-extract-plugin
export default {"downBox":"FileList_downBox__yyO0n"};